import { apiRequest } from '@/utils/request'

export function getXtInstance(queryParams) {
  return apiRequest({
    url: '/XtInstance',
    method: 'get',
    params: queryParams
  })
}

export function getXtInstanceList(queryParams) {
  return apiRequest({
    url: '/XtInstance/GetList',
    method: 'get',
    params: queryParams
  })
}

export function getCaseRecordList(queryParams) {
  return apiRequest({
    url: '/XtInstance/GetCaseRecordList',
    method: 'get',
    params: queryParams
  })
}

export function getOnlineList(queryParams) {
  return apiRequest({
    url: '/XtInstance/GetList',
    method: 'get',
    params: queryParams
  })
}
